var React =         require("react");

let Spinning =      require("../controls/modals/Loading.jsx");
var ImportVersion = require("../controls/importLibrary/ImportVersion.jsx");

class LibraryVersion extends React.Component {

    constructor(){
        super();

        this.state = {showSpinning: {show: false, percent: 0}};
        
        this.onClose = this.onClose.bind(this);
        this.modelImported = this.modelImported.bind(this);
        this.switchSpinning = this.switchSpinning.bind(this);
    }

    onClose(){
        const { history, match:{ params: { id, name }} } = this.props;
        history.push(`/libraries/${id}-${name}`);
    }

    modelImported(id, name){
        this.switchSpinning({show: false});
        this.props.history.push(`/libraries/${id}-${name}`);
    }

    switchSpinning({show, percent = 0}){
        this.setState({ showSpinning: {show, percent} })
    }

    render() {
        let { match: { params: { id, name }}, location: {state: {source} = {source: ""}}} = this.props;
        let {show, percent} = this.state.showSpinning;

        return <React.Fragment>
                    <Spinning show={true} hasClose={true} onClose={this.onClose}>
                        <ImportVersion  id={id} 
                                        name={name}
                                        {...this.props}
                                        source={source}
                                        onClose={this.onClose}
                                        modelImported={this.modelImported}
                                        switchSpinning={this.switchSpinning}/>

                        <Spinning show={show}>
                            <div className="importProgress">
                                <div className="importProgress__message">Uploading new version...</div>
                                <div className="importProgress__bar" style={{width: `${percent}%`}}>{percent}%</div>
                            </div>
                        </Spinning>
                    </Spinning>
                </React.Fragment>
    }
}

module.exports = LibraryVersion;
